import { render, staticRenderFns } from "./RegistrationHeader.vue?vue&type=template&id=382b437a&scoped=true"
import script from "./RegistrationHeader.vue?vue&type=script&lang=js"
export * from "./RegistrationHeader.vue?vue&type=script&lang=js"
import style0 from "./RegistrationHeader.vue?vue&type=style&index=0&id=382b437a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382b437a",
  null
  
)

export default component.exports